import { PlusIcon } from "@heroicons/react/16/solid";
import {
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from "../../../design/sidebar";
import { useMatter } from "../../../contexts/MatterContext";
import { useLocation } from "react-router-dom";
import {
  ArchiveBoxIcon,
  BanknotesIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  ChatBubbleLeftIcon,
  ClockIcon,
  CurrencyDollarIcon,
  DocumentCurrencyDollarIcon,
  DocumentTextIcon,
  FolderIcon,
  GiftIcon,
  HomeIcon,
  LifebuoyIcon,
  LockOpenIcon,
  QuestionMarkCircleIcon,
  StarIcon,
  TrophyIcon,
  UserGroupIcon,
} from "@heroicons/react/20/solid";
import { Badge } from "../../../design/badge";
import { useTask } from "../../../contexts/TaskContext";
import SelectMatterDropdown from "./SelectMatterDropdown";

const UserSidebar = () => {
  const location = useLocation();
  const { taskCounts } = useTask();
  const { matters, currentMatterId, currentMatter } = useMatter();
  return (
    <>
      <SidebarSection>
        <SelectMatterDropdown />

        <SidebarItem
          href="/dashboard"
          id="dashboard-sidebar-item"
          current={location.pathname === "/dashboard"}
        >
          <HomeIcon />
          <SidebarLabel>Overview</SidebarLabel>
        </SidebarItem>
        <SidebarItem
          href="/events"
          id="events-sidebar-item"
          current={location.pathname === "/events"}
        >
          <ClockIcon />
          <SidebarLabel>Incidents</SidebarLabel>
          {taskCounts["event"] > 0 && (
            <Badge color="red">{taskCounts["event"]}</Badge>
          )}
        </SidebarItem>
        <SidebarItem
          href="/conversations"
          id="conversations-sidebar-item"
          current={location.pathname === "/conversations"}
        >
          <ChatBubbleLeftIcon />
          <SidebarLabel>Conversations</SidebarLabel>
        </SidebarItem>
        <SidebarItem
          href="/participants"
          id="participants-sidebar-item"
          current={location.pathname === "/participants"}
        >
          <UserGroupIcon />
          <SidebarLabel>People Involved</SidebarLabel>
        </SidebarItem>
        {/* <SidebarItem
          href="/documents"
          id="documents-sidebar-item"
          current={location.pathname === "/documents"}
        >
          <ArchiveBoxIcon />
          <SidebarLabel>Documents</SidebarLabel>
          {taskCounts["document"] > 0 && (
            <Badge color="red">{taskCounts["document"]}</Badge>
          )}
        </SidebarItem> */}
        {/* <SidebarItem
        href="/tasks"
        id="tasks-sidebar-item"
        current={location.pathname === "/tasks"}
        >
        <ClipboardDocumentCheckIcon />
        <SidebarLabel>Tasks</SidebarLabel>
        </SidebarItem> */}
        <SidebarItem
          href="/discovery-requests"
          id="discovery-requests-sidebar-item"
          current={location.pathname === "/discovery-requests"}
        >
          <QuestionMarkCircleIcon />
          <SidebarLabel>Discovery</SidebarLabel>
        </SidebarItem>
        <SidebarItem
          href="/filings"
          id="filings-sidebar-item"
          current={location.pathname === "/filings"}
        >
          <DocumentTextIcon />
          <SidebarLabel>Filings</SidebarLabel>
        </SidebarItem>

        <SidebarItem href="/finances" id="finances-sidebar-item">
          <CurrencyDollarIcon />
          <SidebarLabel>Property & Finances</SidebarLabel>
          {taskCounts["finance"] > 0 && (
            <Badge color="red">{taskCounts["custody"]}</Badge>
          )}
        </SidebarItem>

        <SidebarItem href="/custody" id="custody-sidebar-item">
          <TrophyIcon />
          <SidebarLabel>Custody & Parenting</SidebarLabel>
          {taskCounts["custody"] > 0 && (
            <Badge color="red">{taskCounts["custody"]}</Badge>
          )}
        </SidebarItem>
      </SidebarSection>

      <SidebarSpacer />
      <SidebarSection>
        {/* <SidebarItem href="/professionals" id="professionals-sidebar-item">
          <BriefcaseIcon />
          <SidebarLabel>Marketplace</SidebarLabel>
        </SidebarItem> */}
        <SidebarItem href="/memberships" id="teamMembers-sidebar-item">
          <LockOpenIcon />
          <SidebarLabel>Team</SidebarLabel>
        </SidebarItem>
        <SidebarItem href={`mailto:info@casetime.com`}>
          <LifebuoyIcon />
          <SidebarLabel>Support</SidebarLabel>
        </SidebarItem>
      </SidebarSection>
    </>
  );
};

export default UserSidebar;
